module.exports = __webpack_public_path__ + "img/car_status_flameout.59033c1f.svg";